export const capabilityData = [
  {
    id: 1,
    title: "Frontend & SERVICE FLOW",
    description:
      "HTML, CSS, JavaScript 기반으로 웹 표준과 접근성을 고려한 퍼블리싱을 수행했으며, React를 활용해 컴포넌트 구조 설계와 UI 개발을 진행했습니다. Spring Boot 기반 REST API 연동 프로젝트를 통해 프론트엔드와 백엔드 간 데이터 흐름을 이해하고 협업 구조를 고려한 개발을 해왔습니다.",
    tags: ["HTML5", "CSS3", "JavaScript (ES6+)", "React"],
  },
  {
    id: 2,
    title: "Design & Tools",
    description:
      "Figma, Adobe XD 기반 디자인 시안을 해석하여 화면에 구현했으며, GitHub와 Jira를 활용해 이슈 관리 및 협업을 진행했습니다.",
    tags: ["Figma", "Adobe XD", "GitHub", "Jira"],
  },
];
